var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-toggle',_vm._g(_vm._b({attrs:{"disable":_vm.loading,"value":_vm.value,"name":_vm.name,"color":_vm.color,"label":_vm.label,"left-label":""},on:{"input":_vm.onUpdate}},'q-toggle',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }